import { render, staticRenderFns } from "./LongTermBreakModal.vue?vue&type=template&id=10f35a01&"
import script from "./LongTermBreakModal.vue?vue&type=script&lang=js&"
export * from "./LongTermBreakModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports